import {
    EventBus,
    inArray,
    Instance,
    NavBar,
    Objekt,
    Service,
} from '@siposdani87/sui-js';
import { app } from '../app';

export class NavBarService extends Service {
    static readonly inject = ['instances'];

    navBar: NavBar;
    eventBus: EventBus;

    constructor(instances: Instance) {
        super();

        this.navBar = instances.navBar;
        this.eventBus = instances.eventBus;
    }

    enter(): void {
        this.eventBus.set('state.change', (state: Objekt) => {
            if (inArray(['site.landing-page', 'pages.show'], state.get<string>('id'))) {
                this.navBar.show();
            } else {
                this.navBar.hide();
            }
        });
    }
}

export const navBarService = app.service('navBarService', NavBarService);
